import { getNoun } from '@utils/lib/getNoun'
import { IconStarFilled } from '@tabler/icons-react'
import React from 'react'

import s from './teacher-sell-card.module.scss'
import classNames from 'classnames'
import { TRIAL_LESSON_PRICE } from '@shared/lib/trial'

export const Stats = ({rating, reviews, appointments_count, grade, isDiscounted, first_lesson_discount, isTrial}) => {
	
	return (
		<div className={s.statsWrapper}>
			<div className={s.statBlock}>
				<div className={s.statHeader}>
					<IconStarFilled className={s.statIcon}/>
					<p className={s.statValue}>{rating}</p>
				</div>
				<span className={s.statLabel}>
					{reviews?.length + " "}
					{getNoun(reviews?.length, "отзыв", "отзыва", "отзывов")}
				</span>
			</div>
			<div className={s.statBlock}>
				<div className={s.statHeader}>
					<p className={s.statValue}>{reviews?.length > appointments_count ? reviews?.length + 2 : appointments_count}</p>
				</div>
				<span className={s.statLabel}>
					{getNoun(reviews?.length > appointments_count ? reviews?.length + 2 : appointments_count, "урок", "урока", "уроков")}
				</span>
			</div>
			<div className={classNames(s.statBlock, s.priceBlock)}>
				<div className={s.statHeader}>
					{isTrial ? '' : (isDiscounted ? <span className={s.discountValue}>-{first_lesson_discount}%</span> : '')}
					<p className={classNames(s.statValue, !isTrial && isDiscounted ? s.discounted : '')}>{isTrial ? `${TRIAL_LESSON_PRICE}₽` : isDiscounted ? `${Math.floor(grade?.price * ((100 - first_lesson_discount)/100))}₽` : `${grade?.price}₽`}</p>
				</div>
				<span className={s.statLabel}>{isTrial ? `пробное занятие` : isDiscounted ? 'скидка на 1 урок' : 'стоимость'} </span>
			</div>
		</div>

	)
}
